<template>

    <v-app-bar
      fixed dark
      :color="bg_color"
      :elevation="shadow"
    >
      <v-container>

        <!-- only appear in mobile screen -->
        <div class="d-block d-md-none">

          <div class="d-flex justify-space-between align-center">

            <!-- dropdown button for navigation -->
            <v-menu 
              offset-y
              transition="slide-y-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, index) in nav"
                    :key="index"
                    :to="item.link"
                    link
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ $t(item.label) }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <!-- dropdown button for navigation -->

            <!-- logo when floating -->
            <router-link 
              to="/"
              v-show="floating"
            >
              <img
                src="@/assets/logo.png"
                class="mt-2"
                height="64px"
              />
            </router-link>
            <!-- logo when floating -->
            <!-- page name when not floating -->
            <h4
              class="font-weight-thin"
              v-show="!floating && $route.name != 'home'"
            >{{ $t("nav." + $route.name) }}
            </h4>
            <!-- page name when not floating -->

            <!-- dropdown button for language switching -->
            <v-menu 
              offset-y
              transition="slide-y-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-translate</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item-group
                  v-model="locale"
                >
                  <v-list-item
                    v-for="(lang, index) in languages"
                    :value="lang.name"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ lang.label }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <!-- dropdown button for language switching -->

          </div>

        </div>
        <!-- only appear in mobile screen -->

        <!-- only appear in desktop screen -->
        <div class="d-none d-md-block">

          <div class="d-flex align-center">

            <!-- logo -->
            <router-link 
              to="/"
              v-show="floating"
            >
              <img
                src="@/assets/logo.png"
                class="mt-2 mr-4"
                height="64px"
              />
            </router-link>
            <!-- logo -->

            <!-- navigation -->
            <div 
              class="flex-grow-1"
              v-bind:class="{ 'text-left': floating }"
            >
              <v-btn
                v-for="(item, index) in nav"
                :key="index"
                :to="item.link"
                text
              >{{ $t(item.label) }}</v-btn>
            </div>
            <!-- navigation -->

            <!-- dropdown button for language switching -->
            <v-menu 
              offset-y
              transition="slide-y-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-translate</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item-group
                  v-model="locale"
                >
                  <v-list-item
                    v-for="(lang, index) in languages"
                    :value="lang.name"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ lang.label }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <!-- dropdown button for language switching -->

          </div>
        </div>

      </v-container>
    </v-app-bar>

</template>

<script>
  import i18n from '@/i18n'
  export default {
    name: 'HeaderComponent',

    data: () => ({
      nav: [
        {
          label: 'nav.home',
          link: '/',
        },
        {
          label: 'nav.about',
          link: '/about',
        },
        {
          label: 'nav.service',
          link: '/service',
        },
        {
          label: 'nav.portfolio',
          link: '/portfolio',
        },
        {
          label: 'nav.contact',
          link: '/contact',
        },
      ],
      languages: [
        {
          name: 'en',
          label: 'English'
        },
        {
          name: 'zh-hk',
          label: '䌓體中文'
        },
        {
          name: 'zh-cn',
          label: '简体中文'
        },
        {
          name: 'jp',
          label: '日本語'
        },
        {
          name: 'de',
          label: 'Deutsch'
        }
        // {
        //   name: 'tb',
        //   label: 'བོད་སྐད།'
        // }
      ],
      floating: false,
      bg_color: null,
      shadow: 0,
      locale: i18n.locale
    }),

    mounted() {
      window.onscroll = () => {
        this.scrollWindow();
      }
      this.scrollWindow();
    },

    methods: {
      scrollWindow() {
        if(document.body.scrollTop > 100 || document.documentElement.scrollTop > 100)
        {
          // scrolling
          this.floating = true;
          this.bg_color = 'blue darken-4';
          this.shadow = 24;
        } 
        else 
        {
          // on the top
          this.floating = false;
          this.bg_color = 'transparent';
          this.shadow = 0;
        }
      }
    },

    watch: {
      locale(newVal) {
        i18n.locale = newVal;
        localStorage.setItem('locale', newVal);
      }
    }

  }
</script>
